import auth from 'api/auth.js';

export const switchAccount = (account_id) => (dispatch) => {
  dispatch({ type: 'SWITCH_ACCOUNT' });
  return auth.switchAccount(account_id)
    .end((response) => {
      if (response.error) {
        dispatch({
          type: 'SWITCHED_ACCOUNT',
          status: 'error',
          messages: response.status,
          details: response.body,
        });
      } else if (response.ok) {
        dispatch({
          type: 'SWITCHED_ACCOUNT',
          status: 'success',
          account_id,
        });
        // once the account is switched, we just hard reload the page & let the init flow do its job
        window.location = `/blueprint`;
      }
    });
};
